
const svg = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" role="img"><path d="M3 3V11L10 12L3 13V21L23 12L3 3Z" fill="currentColor"></path></svg>';export default svg;
    